import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';

const BiToolTable = ({ data, loading, onPageChange, onPageSizeChange, pageFilter }) => {
  const [state, updateState] = useState({
    detailModal: false,
  });

  //const { data, loading, currentPage, pageSize, records } = state;

  const setState = obj => updateState(pre => ({ ...pre, ...obj }));
  const columns =[
    {
        dataField: 'coveredEntity',
        text: 'Covered Entity',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'pharmacyName',
        text: 'Pharmacy Name',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'pharmacyNPI',
        text: 'Pharmacy NABP or NPI',
        sort: true,
        width: 165,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'transactionCode',
        text: 'Transaction Code',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'bin',
        text: 'BIN',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'pcn',
        text: 'PCN',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'group',
        text: 'Group',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'SecondaryBIN',
        text: 'Secondary BIN',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'SecondaryPCN',
        text: 'Secondary PCN',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'secondaryGroupNumber',
        text: 'Secondary Group Number',
        sort: true,
        width: 175,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'otherCoverageCode',
        text: 'Other Coverage Code',
        sort: true,
        width: 148,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'submissionClarificationCode',
        text: 'Submission Clarification Code',
        sort: true,
        width: 200,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'rx',
        text: 'Rx #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'refill',
        text: 'Refill',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'switchDate',
        text: 'Switch Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'writtenDate',
        text: 'Written Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'serviceDate',
        text: 'Service Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'claimCapturedDate',
        text: 'Claim Captured Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'prescriber',
        text: 'Prescriber',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'prescriberNPI',
        text: 'Prescriber NPI',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'ndc',
        text: 'NDC',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'drugName',
        text: 'Drug Name',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'mfgName',
        text: 'Mfg. Name',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'brandOrGeneric',
        text: 'Brand Or Generic',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'qty',
        text: 'Qty',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'daysSupply',
        text: 'Days Supply',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'copay',
        text: 'Copay',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'insurancePayment',
        text: 'Insurance Payment',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'totalPaid',
        text: 'Total Paid',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'estWACRetailCost',
        text: 'Est WAC Retail Cost',
        sort: true,
        width: 160,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'estNon340BNetProfit',
        text: 'Est Retail Net Profit',
        sort: true,
        width: 180,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'dispenseFee',
        text: 'Dispense Fee',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'est340BNetProfit',
        text: 'Est 340B Net Profit',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'claimType',
        text: 'Claim Type',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'claimSubType',
        text: 'Claim Sub Type',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'reason',
        text: 'Reason',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'subReason',
        text: 'Sub Reason',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'replenishment',
        text: 'Replenishment %',
        sort: true,
        width: 145,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'replenishmentPO',
        text: 'Replenishment PO #',
        sort: true,
        width: 160,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'replenishmentInvoice',
        text: 'Replenishment Invoice #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'billingModel',
        text: 'Billing Model',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'truedUpUnits',
        text: 'Trued Up Units',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'truedUpCost',
        text: 'Trued Up Cost',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'truedUpDate',
        text: 'Trued Up Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
];
    return (
    <div
      className="table-card scroll-table position-relative border-0 rounded pt-0"
      fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id={'reportsTable'}
        hasPagination
        loading={loading}
        data={data}
        columns={columns}
        onExport={() => ''}
        pageSize={pageFilter.pageSize}
        currentPage={pageFilter.page}
        totalRecords={pageFilter.records}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  )
}

export default BiToolTable;